/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Create_BookingInputs */

const en_admin_dashboard_create_booking = /** @type {(inputs: Admin_Dashboard_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Booking`)
};

const de_admin_dashboard_create_booking = /** @type {(inputs: Admin_Dashboard_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Buchung`)
};

const es_admin_dashboard_create_booking = /** @type {(inputs: Admin_Dashboard_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear reserva`)
};

const fr_admin_dashboard_create_booking = /** @type {(inputs: Admin_Dashboard_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une réservation`)
};

const it_admin_dashboard_create_booking = /** @type {(inputs: Admin_Dashboard_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea prenotazione`)
};

const pt_br2_admin_dashboard_create_booking = /** @type {(inputs: Admin_Dashboard_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar reserva`)
};

const pl_admin_dashboard_create_booking = /** @type {(inputs: Admin_Dashboard_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz rezerwację`)
};

const hu_admin_dashboard_create_booking = /** @type {(inputs: Admin_Dashboard_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalás létrehozása`)
};

const ro_admin_dashboard_create_booking = /** @type {(inputs: Admin_Dashboard_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creati Rezervare`)
};

/**
* | output |
* | --- |
* | "Create Booking" |
*
* @param {Admin_Dashboard_Create_BookingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_create_booking = /** @type {((inputs?: Admin_Dashboard_Create_BookingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Create_BookingInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_create_booking(inputs)
	if (locale === "de") return de_admin_dashboard_create_booking(inputs)
	if (locale === "es") return es_admin_dashboard_create_booking(inputs)
	if (locale === "fr") return fr_admin_dashboard_create_booking(inputs)
	if (locale === "it") return it_admin_dashboard_create_booking(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_create_booking(inputs)
	if (locale === "pl") return pl_admin_dashboard_create_booking(inputs)
	if (locale === "hu") return hu_admin_dashboard_create_booking(inputs)
	return ro_admin_dashboard_create_booking(inputs)
});
export { admin_dashboard_create_booking as "admin.dashboard.create_booking" }